/* eslint-disable */
import * as util from "@/api/license";

const state = {
    numAgentTotal: 0,
    numMessageTotal: 0,
    fieldsGetLicenseList: {
        license_name: "",
        license_phone_number: "",
        license_status: "",
        page: 0,
        perPage: 100
    }
};


const mutations = {
    SET_numAgentTotal: (state, value) => {
        state.numAgentTotal = value
    },
    SET_numMessageTotal: (state, value) => {
        state.numMessageTotal = value
    },
    SET_fieldsGetLicenseList: (state, value) => {
        state.fieldsGetLicenseList = value
    },
};

const actions = {
    emptyOutbox({ commit }, params) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.emptyOutbox(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    emptyInbox({ commit }, params) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.emptyInbox(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    generateLicenseKey({ commit }, params) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.generateLicenseKey(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getAgentTotal({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.getAgentTotal(params).then(response => {
                const { data } = response;
                commit("SET_numAgentTotal", data);
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getMessageTotal({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.getMessageTotal(dataParams).then(response => {
                const { data } = response;
                commit("SET_numMessageTotal", data);
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    setFieldsGetLicenseList({ commit }, data) {
        commit("SET_fieldsGetLicenseList", data);
    },
    updateStored({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.updateStored(dataParams).then(response => {
                // const { data } = response;
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getLicenseById({ commit }, id) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.getLicenseById(id).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getLicenseList({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.getLicenseList(dataParams).then(response => {
                // const { data } = response;
                commit("SET_fieldsGetLicenseList", dataParams);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    createStored({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.createStored(dataParams).then(response => {
                // const { data } = response;
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/license.js